import React, { FC } from "react";
import { ActionsGroup, Dialog, DialogActions, FlatButton, Input, RaisedButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { DialogContent } from "./styled";
import { useDialogInfo } from "../../../hooks/useDialogs";
import { useClassificationTitle } from "./hooks/useClassificationTitle";

export const CLASSIFICATION_TITLE_DEFAULTS = {
  maxWidth: "38.125rem",
};

export const ClassificationTitle: FC = () => {
  const { t } = useTranslation();

  const {
    resources: [index],
    closeDialog,
  } = useDialogInfo(true);

  const { title, saveTitle, updateTitle } = useClassificationTitle(+index);

  return (
    <Dialog isOpen onCloseRequest={closeDialog} onApply={saveTitle} maxWidth={CLASSIFICATION_TITLE_DEFAULTS.maxWidth}>
      <DialogContent>
        <Input
          label={t("classification.classLegendLabel", { ns: "dialogs" })}
          value={title}
          onChange={updateTitle}
          width={"100%"}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton onClick={saveTitle} primary>
            {t("actions.save", { ns: "common" })}
          </RaisedButton>
          <FlatButton onClick={closeDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
